import styled from "styled-components";
import RoundedCard from "../../components/RoundedCard";
import { flags } from "../../featureFlags";
import { routes } from "../../routes";

const ScrollableTabs = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    grid-auto-rows: 1fr;
    grid-gap: 32px;
`;

const Publish = () => {
  return (
    <ScrollableTabs>
      <RoundedCard
        title="Publish to GitHub"
        description="Create a GitHub repository from your metadata sheet."
        icon="../logo_github.svg"
        linkTo={routes.publishGitHub.absolute}
        disable={!flags.publishGitHub}
      />
    </ScrollableTabs>
  );
};

export default Publish;
